import React from 'react';
import { Compass, TrendingUp, Users, CheckCircle2 } from 'lucide-react';
const values = [{
  icon: Compass,
  title: 'Find your',
  subtitle: 'direction'
}, {
  icon: TrendingUp,
  title: 'Build confidence',
  subtitle: 'and skills'
}, {
  icon: Users,
  title: 'Make meaningful',
  subtitle: 'moves'
}, {
  icon: CheckCircle2,
  title: 'Ongoing support',
  subtitle: 'that gets results'
}];
export function ValueBar() {
  return <div className="w-full border-y border-teal/10 bg-ivory/50" data-id="element-190">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-10" data-id="element-191">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-192">
          {values.map((value, idx) => <div key={idx} className="flex items-center gap-4" data-id="element-193">
              <div className="w-12 h-12 rounded-full border border-teal/20 flex items-center justify-center text-teal bg-white shrink-0" data-id="element-194">
                <value.icon className="w-5 h-5" data-id="element-195" />
              </div>
              <div className="text-sm font-medium leading-tight" data-id="element-196">
                <div className="text-ink" data-id="element-197">{value.title}</div>
                <div className="text-ink/70" data-id="element-198">{value.subtitle}</div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}